import React from 'react';

const StatusFilter = ({ statusOptions, filters, toggleStatusFilter, setStatusFilterOnly }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Status</h3>
      <div className="space-y-2">
        {statusOptions.map(status => (
          <div key={status} className="flex items-center gap-3 group/status">
            <div className="flex h-6 shrink-0 items-center">
              <div className="group grid size-4 grid-cols-1">
                <input
                  id={`status-${status}`}
                  name={`status-${status}`}
                  type="checkbox"
                  checked={filters.status.includes(status)}
                  onChange={() => toggleStatusFilter(status)}
                  className="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto dark:border-gray-600 dark:bg-gray-800"
                />
                <svg
                  fill="none"
                  viewBox="0 0 14 14"
                  className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25"
                >
                  <path
                    d="M3 8L6 11L11 3.5"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={filters.status.includes(status) ? 'opacity-100' : 'opacity-0'}
                  />
                  <path
                    d="M3 7H11"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="opacity-0 group-has-indeterminate:opacity-100"
                  />
                </svg>
              </div>
            </div>
            <div className="text-sm/6 flex-grow flex items-center">
              <label htmlFor={`status-${status}`} className="font-medium text-gray-700 dark:text-gray-300">
                {status}
              </label>
              <button
                type="button"
                onClick={() => setStatusFilterOnly(status)}
                className="ml-1.5 text-xs text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 opacity-0 group-hover/status:opacity-100 transition-opacity duration-150"
              >
                only
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter;